import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { translate } from 'react-i18next';
import cn from 'classnames';
import Icon from '../Icon/Icon';
import { ResearchStoreProp } from '../../stores/props';
import BrowserStore from '../../browser/stores/BrowserStore';
import { isFuse5Enabled } from '../../fuseFeatureFlag';
import OldUserAgentLabel from './OldUserAgentLabel';
import './UserAgentLabel.css';

class NewUserAgentLabel extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        browser: BrowserStore.PropType.isRequired,
        research: ResearchStoreProp,
    };

    renderContent() {
        const { t, research } = this.props;
        if (!research.userAgent) {
            return <div style={{ width: 144 }}>{t('userAgentMenu.barTitle')} </div>;
        }

        const { os, browser } = research.getUserAgentInfo(research.userAgent);
        if (os && browser) {
            return <Fragment>
                <Icon
                    type={`os_${os.toLowerCase()}`}
                />
                <span>{t(`userAgentMenu.${os}`)}</span>
                <Icon
                    type={`browser_${browser.toLowerCase()}`}
                />
                <span>{t(`userAgentMenu.${browser}`)}</span>
                <Icon
                    type="close"
                    style={{ cursor: 'pointer' }}
                    onClick={() => research.setUserAgent(null)}
                    title={t('userAgentMenu.reset')}
                />
            </Fragment>;
        }

        return <Fragment>
            <span
                className="UserAgentLabel__Text"
                title={research.userAgent}
            >{research.userAgent}</span>
            <Icon
                type="close"
                style={{ cursor: 'pointer' }}
                onClick={() => research.setUserAgent(null)}
                title={t('userAgentMenu.reset')}
            />
        </Fragment>;
    }

    render() {
        return <div className={cn('NewUserAgentLabel', this.props.className)}>
            {this.renderContent()}
        </div>;
    }
}

const WrappedNewUserAgentLabel = translate()(inject('research', 'browser')(observer(NewUserAgentLabel)));

const UserAgentLabel = (props) => {
    return isFuse5Enabled() ? <WrappedNewUserAgentLabel {...props} /> : <OldUserAgentLabel {...props} />;
};

export default UserAgentLabel;
